export const AccountPriceListColDef = [
  {
    headerClass: "primary",
    colId: "Warehouse",
    field: "Warehouse",
    width: 140,
    // enableRowGroup: true,
    // enablePivot: true,
    pinned: true,
    // editable: true,
    filter: "text",
    // rowGroup: true,
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerClass: "primary",
    colId: "Category",
    field: "Category",
    width: 130,
    pinned: true,
    filter: "text",
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerName: "Product Name",
    headerClass: "primary",
    colId: "Product_Name",
    field: "Product_Name",
    width: 160,
    // enableRowGroup: true,
    // enablePivot: true,
    pinned: true,
    // editable: true,
    filter: "text",
    // rowGroup: true,
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerName: "ProductCode",
    headerClass: "primary",
    colId: "ProductCode",
    field: "ProductCode",
    width: 120,
    // enableRowGroup: true,
    // enablePivot: true,
    pinned: true,
    // editable: true,
    filter: "text",
    // rowGroup: true,
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerName: "PriceList",
    headerClass: "primary",
    colId: "Pricelist",
    field: "Pricelist",
    width: 190,
    // enableRowGroup: true,
    // enablePivot: true,
    // pinned: true,
    // editable: true,
    filter: "text",
    // rowGroup: true,
    cellRenderer: "agGroupCellRenderer",
  },
  {
    headerClass: "primary",
    headerName: "MRP",
    field: "MRP",
    width: 100,
    // enableRowGroup: true,
    // pinned: true,
    // enablePivot: true,
    filter: "text",
    // rowGroup: true,
    cellRenderer: "agGroupCellRenderer",
    type: "rightAligned",
  },
  {
    headerClass: "primary",
    headerName: "Retailer Margin %",
    colId: "Retailer_Margin",
    field: "Retailer_Margin",
    width: 180,
    filter: "text",
    cellRenderer: (params) => {
      return params.value ? `${(params.value * 100).toFixed(2)} %` : "0%";
    },
    type: "rightAligned",
  },
  {
    headerClass: "primary",
    headerName: "PTR",
    colId: "PTR",
    field: "PTR",
    filter: "text",
    width: 100,
    valueFormatter: (params) => {
      return params.value ? params.value.toFixed(2) : "0";
    },
    type: "rightAligned",
  },
  {
    headerClass: "primary",
    headerName: "Tax %",
    colId: "Tax",
    field: "Tax",
    width: 110,
    filter: "text",
    cellRenderer: (params) => {
      return params.value ? `${params.value * 100} %` : "0%";
    },
    type: "rightAligned",
  },
  {
    headerClass: "primary",
    headerName: "Net PTR",
    colId: "Net_PTR",
    field: "Net_PTR",
    filter: "text",
    width: 120,
    valueFormatter: (params) => {
      return params.value ? params.value.toFixed(2) : "0";
    },
    type: "rightAligned",
  },

  {
    headerClass: "primary",
    headerName: "From Date",
    colId: "From_Date",
    field: "From_Date",
    width: 140,
    // enableRowGroup: true,
    // enablePivot: true,
    filter: "text",
    // hide: true,
    valueFormatter: (params) => {
      if (!params.value) return "";
      const date = new Date(params.value);
      if (isNaN(date)) return "";
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const day = date.getDate().toString().padStart(2, "0");
      return `${day}-${month}-${date.getFullYear()}`;
    },
  },

  {
    headerClass: "primary",
    headerName: "To Date",
    colId: "To_Date",
    field: "To_Date",
    filter: "text",
    width: 120,
    valueFormatter: (params) => {
      if (!params.value) return '';
      const date = new Date(params.value);
      if (isNaN(date)) return '';
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${day}-${month}-${date.getFullYear()}`;
    }
  },
];
